export default __webpack_public_path__ + "static/media/banner.38beb1f5.png";